module.exports = __webpack_public_path__ + "img/1517216716.db6cbd2d.jpg";